import { GameApp } from './app/GameApp.js';

window.addEventListener('DOMContentLoaded', async () => {
  const app = new GameApp();
  window.__GAME_APP__ = app;
  await app.init();
});
